import { render, staticRenderFns } from "./surface_post_moderation.vue?vue&type=template&id=8d6ad67a&scoped=true&"
import script from "./surface_post_moderation.vue?vue&type=script&lang=js&"
export * from "./surface_post_moderation.vue?vue&type=script&lang=js&"
import style0 from "./surface_post_moderation.vue?vue&type=style&index=0&id=8d6ad67a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d6ad67a",
  null
  
)

export default component.exports